import { useQuery } from "@tanstack/react-query";

import { attendance } from "../api/attendance";

export const useGetAttendanceId = () => {
  return useQuery({
    queryKey: ["attendance-id"],
    queryFn: attendance.getAttendanceId,
    select: (res) => res,
  });
};
